import PropTypes from 'prop-types';

export const ListingText = ({ item }) => {
  return <>{item.CroppedDescription || item.description}</>;
};

ListingText.propTypes = {
  item: PropTypes.object,
};

export default ListingText;
